// How many times a GIF in the message list plays before it stops on its last frame (#489). A choice kept on each
// device (Settings → Appearance → GIF plays), never sent to the server. The lightbox and the GIF picker's previews
// ignore it and loop. The values, labels and rule are in shared/cases/gif-plays.json, which every client's test reads.
export type GifPlays = "once" | "three" | "forever";

/** The choices in the order every client lists them. `plays`: how many plays, or null for never stopping. */
export const GIF_PLAYS: readonly { id: GifPlays; label: string; plays: number | null }[] = [
  { id: "once", label: "Once", plays: 1 },
  { id: "three", label: "3 times", plays: 3 },
  { id: "forever", label: "Forever", plays: null },
];
export const DEFAULT_GIF_PLAYS: GifPlays = "three";

/** A stored value as a choice; anything else (missing, old, edited by hand) is the default. */
export function parseGifPlays(raw: unknown): GifPlays {
  return GIF_PLAYS.some((c) => c.id === raw) ? (raw as GifPlays) : DEFAULT_GIF_PLAYS;
}

/** After `played` plays, is it time to stop? A GIF set to "forever" never is. */
export function gifShouldStop(choice: GifPlays, played: number): boolean {
  const plays = GIF_PLAYS.find((c) => c.id === choice)?.plays ?? null;
  return plays !== null && played >= plays;
}
